// Catch the URL of the stylesheet that contains the fonts

export const getFontStylesheetUrl = () => {
  document.querySelector("[data-stylesheet-target]")?.href;
};
